import { useEffect } from "react"
import { IntegrationIframeMessage, IntegrationReqType, IntegrationResType } from "../../models/project"
import { User } from "../../models/user"

export const useIntegrationFrameBridge = (user: User | undefined) => {
    useEffect(() => {
        const processMessage = (event: MessageEvent<IntegrationIframeMessage>) => {
            const data = event.data
            if (data.notificationType === IntegrationReqType.GetUser && event.source) {
                event.source.postMessage({ notificationType: IntegrationResType.SendUser, message: user })
            }
        }
        window.addEventListener("message", processMessage)
        return () => {
            window.removeEventListener("message", processMessage)
        }
    }, [user])
}
